import { Fragment, useState, useEffect } from "react";
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { classNames } from 'primereact/utils';
import { useCookies } from 'react-cookie';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { Chip } from 'primereact/chip';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import { login, setRoles, setPermissions } from '../../services/store/userSlice';
import { AuthService } from "../../services";
import './style.scss';
import SSOLogin from "../../components/sso_login/sso_login";
import properties from "../../config/environmentProperties";
import { parseRolePermission } from '../../services/utility/helper';
import CryptoJS from "crypto-js";
import appPakage from '../../../package.json';
const INIT_FORM_VAL = { email: '', semail: '', password: '', accept: false }

const Login = ({ screen }) => {
    const secretPass = "EXkShZPG4IfW2Rt2EW";
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [showMessage, setShowMessage] = useState(false);
    const [isLoggedIn, setLoggedIn] = useState(false);
    const [formData, setFormData] = useState({});
    const [cookies, setCookie] = useCookies(['token']);


    const conf = properties.currentEnvironment;
    const formik = useFormik({
        initialValues: INIT_FORM_VAL,
        validate: (data) => {
            let errors = {};

            if (!data.email) {
                errors.email = 'Email/Username is required.';
            }

            if (!data.password) {
                errors.password = 'Password is required.';
            }
            return errors;
        },
        onSubmit: (data) => {
            setFormData(data);
            if (isLoggedIn) {
                loadProfile(data);
            } else {
                getLogin(data);
            }
            setShowMessage(true);
            // formik.resetForm();
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    function save2Local(obj) {
        localStorage.setItem('userPrinciple', obj.user.email)
        localStorage.removeItem('inactive')
    }

    const getLogin = async (data) => {
        const payload = { ...data };
        payload.email = data.email.includes('@') ? data.email : data.email + '@espire.com';
        try {
            AuthService.loginWithEmail(payload, cookies.token).then(resp => {
                let userObj = resp.data;
                if (userObj.success) {
                    if (data.email == conf.serviceAccount) {
                        setLoggedIn(true);
                    } else {
                        createSession(userObj);
                    }
                } else {
                    toast.error("User not found...");
                }
            }, err => {
                const errResp = err.response.data;
                toast.error(errResp.error);
            })
        } catch (error) {
            console.log("error on calling api", error)
        }


    }

    const createSession = (userObj) => {
        const { roles, permissions } = parseRolePermission(userObj.user.UserRoles);
        userObj.user['roles'] = [(userObj.user.type === 'MANAGER' ? 'manager' : 'employee'), ...roles];
        userObj.user['show_roles'] = [...roles];
        userObj.user['permissions'] = permissions;
        userObj.user['loggedIn'] = true;
        delete (userObj.user['password']);
        const info = null;
        const result = { ...userObj, ...info }
        dispatch(login(result));
        dispatch(setRoles([(userObj.type === 'MANAGER' ? 'manager' : 'employee'), ...roles]));
        dispatch(setPermissions(permissions));
        save2Local(result);
        navigate('/dashboard');
    }

    const loadProfile = (params) => {
        const pwd = CryptoJS.AES.encrypt(JSON.stringify(params.password), secretPass).toString();
        const payload = { email: params.semail == null || params.semail == '' ? params.email : params.semail, password: cookies.msid };
        console.log("Load Profile payload", payload)
        try {
            AuthService.loginWithSSO(payload, cookies.token).then(resp => {
                let userObj = resp.data;
                if (userObj.success) {
                    createSession(userObj);
                } else {
                    toast.error("User not found...");
                }
            }, err => {
                const errResp = err.response.data;
                toast.error(errResp.error);
            })
        } catch (error) {
            console.log("error on calling api", error)
        }
    }

    const UserEmail = () => {
        return (
            <div className="p-fluid" style={{ textAlign: 'left' }}>
                <h2 style={{ color: '#0f0830', textAlign: 'center' }}>Logged-In with service account</h2>
                <p><Chip label="You can login with other's email account also for service perpose." icon="pi pi-info" className="mr-2 mb-2 custom-chip" /></p>
                <form onSubmit={formik.handleSubmit} className="p-fluid">
                    <div className="field">
                        <label className={classNames({ 'p-error': isFormFieldValid('semail') })}>Email Address</label>
                        <span className="p-float-label p-input-icon-right">
                            <i className="pi pi-envelope" />
                            <InputText name="semail" value={formik.values.semail} onChange={formik.handleChange}
                                className={classNames({ 'p-invalid': isFormFieldValid('semail') })} placeholder="Enter your email address" />
                        </span>
                        {getFormErrorMessage('semail')}
                    </div>
                    <Button type="submit" label="Go to Dashboard" className="mt-2" />
                </form>
            </div>
        );
    }

    const LoginWrapper = () => {
        return (
            <div className="login-wrapper">
                <div className="login-form">
                    <p>
                        <img className="logo" src="/assets/images/logo.png" />
                    </p>
                    {conf.enableSSO ? <>
                        <h1>Self Service Portal</h1>
                        <SSOLogin />
                    </> : <>
                        {isLoggedIn ? <>{UserEmail()} </> :
                            <form onSubmit={formik.handleSubmit} className="p-fluid">
                                <h3>Welcome Back</h3>
                                <p>Enter your credentials to access your account</p>
                                <div className="field">
                                    <label className={classNames({ 'p-error': isFormFieldValid('email') })}>Email Address</label>
                                    <span style={{ borderStyle: 'solid', borderRadius: '8px', borderColor: '#5479d9f2' }} className="p-float-label p-input-icon-right">
                                        <i className="pi pi-envelope" />
                                        <InputText name="email" value={formik.values.email} onChange={formik.handleChange}
                                            className={classNames({ 'p-invalid': isFormFieldValid('email') })} placeholder="Enter your email address" />
                                    </span>
                                    {getFormErrorMessage('email')}
                                </div>
                                <div className="field">
                                    <label className={classNames({ 'p-error': isFormFieldValid('password') })}>Password</label>
                                    <span style={{ borderStyle: 'solid', borderRadius: '8px', borderColor: '#5479d9f2' }} className="p-float-label">
                                        <Password name="password" value={formik.values.password} onChange={formik.handleChange} toggleMask feedback={false}
                                            autoComplete="false"
                                            className={classNames({ 'p-invalid': isFormFieldValid('password') })} placeholder="Enter your password" />
                                    </span>
                                    {getFormErrorMessage('password')}
                                </div>
                                <div className="field-checkbox">
                                    <Checkbox inputId="accept" name="accept" checked={formik.values.accept} onChange={formik.handleChange} className={classNames({ 'p-invalid': isFormFieldValid('accept') })} />
                                    <label htmlFor="accept" className={classNames({ 'p-error': isFormFieldValid('accept') })}>Remember me</label>
                                </div>

                                <Button type="submit" style={{ borderRadius: '6px' }} label="Submit" className="mt-2" />
                            </form>}
                    </>}
                </div>
                <p><small>ESS V {appPakage?.version}</small></p>


            </div>
        )
    }

    return (
        <div className="grid full-screen lg-screen">
            <div className="col-6 banner">
                <div className="image"></div>
                <h1>All-in-one Workspace</h1>
                <p>
                    <em>Timesheet, Leaves, Payroll and get organized.</em>
                    <em><strong>ESS</strong> is all you need - in one tool</em>
                    {/* <small>@2023, Espire Infolab Pvt. Ltd. All Rights Reserved</small> */}
                    <small>Espire Infolab Pvt. Ltd.</small>
                </p>
            </div>
            <div className="col-6 login-area">
                {LoginWrapper()}
            </div>
        </div>
    )
}

export default Login;